import type {
	AgentsRepository,
	ListAgentsParams
} from '~~/core/ports/repositories/AgentsRepository';
import type { NuxtGetAgentApiReturn } from '~~/server/api/agents/[slug].get';
import type { NuxtListAgentsApiReturn } from '~~/server/api/agents/index.get';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';

export const nuxtAgentsRepository: Pick<AgentsRepository, 'list' | 'getOne'> = {
	async list(params: ListAgentsParams, signal?: AbortSignal) {
		try {
			const response = await $fetch<NuxtListAgentsApiReturn>('/api/agents', {
				method: 'GET',
				query: params,
				signal
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while fetching agents from the API.',
				source: 'nuxtAgentsRepository.list',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async getOne(slug, signal) {
		try {
			const response = await $fetch<NuxtGetAgentApiReturn>(
				`/api/agents/${encodeURIComponent(slug)}`,
				{
					method: 'GET',
					signal
				}
			);

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while fetching agent from the API.',
				source: 'nuxtAgentsRepository.getOne',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	}
};
